export const PLUGIN_TYPES = Object.freeze({
  READING_TYPE: 'reading-type',
  WIDGET: 'widget',
  THEME: 'theme',
  ROUTE: 'route',
  API: 'api',
  STORE: 'store',
  COMPOSITE: 'composite',
});

export const PLUGIN_STATES = Object.freeze({
  REGISTERED: 'registered',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ERROR: 'error',
});

export function validateManifest(manifest) {
  const errors = [];

  if (!manifest.name || typeof manifest.name !== 'string') {
    errors.push('Plugin must have a valid "name" (string).');
  }
  if (!manifest.version || typeof manifest.version !== 'string') {
    errors.push('Plugin must have a valid "version" (string).');
  }
  if (!manifest.type || !Object.values(PLUGIN_TYPES).includes(manifest.type)) {
    errors.push(`Plugin must have a valid "type" (one of: ${Object.values(PLUGIN_TYPES).join(', ')}).`);
  }
  if (typeof manifest.install !== 'function') {
    errors.push('Plugin must have an "install" function.');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
